<div>
  <h1 class="text-2xl font-bold mb-4">Detalhes do vendedor</h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  @if (loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary"/>
    </div>
  }

  @if (!loading && sellerInfo) {
    <div class="mb-6 space-y-1 dark:text-white">
      <div><span class="font-semibold">ID:</span> {{ sellerInfo.id }}</div>
      <div class="flex items-center gap-2">
        <span class="font-semibold">Document ID:</span> {{ sellerInfo.documentId || 'Não tem' }}
        @if (!sellerInfo.documentId) {
          <app-button color="primary" rounded="full" size="small" [loading]="workingLoading" (click)="doSyncRequest()">Sincronizar</app-button>
        }
      </div>
      <div><span class="font-semibold">Nome:</span> {{ sellerInfo.name }}</div>
      <div><span class="font-semibold">Email:</span> {{ sellerInfo.email }}</div>
      <div><span class="font-semibold">Grupo:</span> {{ sellerInfo.group }}</div>
      <div><span class="font-semibold">Role:</span> {{ sellerInfo.role }}</div>
      <div><span class="font-semibold">Salesman:</span> {{ sellerInfo.salesMan }}</div>
      <div><span class="font-semibold">Seller type:</span> {{ sellerInfo.sellerType }}</div>
      <div><span class="font-semibold">Store:</span> {{ `${sellerInfo.storeId} - ${sellerInfo.storeDescription} (${sellerInfo.storeName})` }}</div>

      <div>
        <p><span class="font-semibold">Price list:</span></p>
        <ol>
          @for (pl of sellerInfo.priceList; track pl) {
            <li>{{ pl }}</li>
          } @empty {
            <li>Sem price list.</li>
          }
        </ol>
      </div>
      <div>
        <p><span class="font-semibold">Product lines:</span></p>
        <ol>
          @for (pl of sellerInfo.productLines; track pl) {
            <li>{{ pl }}</li>
          } @empty {
            <li>Sem product lines.</li>
          }
        </ol>
      </div>

      <div><span class="font-semibold">Criado em:</span> {{ sellerInfo.createdAt }}</div>
      <div><span class="font-semibold">Atualizado em:</span> {{ sellerInfo.updatedAt }}</div>

      <div><span class="font-semibold">Autorizado:</span> {{ sellerInfo.authorized }}</div>
      <div><span class="font-semibold">Permite carrinho novo:</span> {{ sellerInfo.enabledNewCart }}</div>
      <div><span class="font-semibold">Expedition pending:</span> {{ sellerInfo.expeditionPending }}</div>
      <div><span class="font-semibold">Golden products:</span> {{ sellerInfo.goldenProducts }}</div>
      <div><span class="font-semibold">Venda pinpad remota:</span> {{ sellerInfo.isPinPadRemoteSale }}</div>
    </div>

    <div class="mb-6 space-y-1">
      <app-accordion>
        <app-accordion-item id="manage-seller" icon="user-plus" label="Gerenciar Master Data">
          <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="sellerInfoData" (onInit)="onEditorInit($event)"></ngx-monaco-editor>
          @if (sellerInfo.existsInVtex) {
            <p>Usuário já existe no MasterData da VTEX. Você pode atualizá-lo ou excluí-lo, o que deseja fazer?</p>
            <p class="flex gap-2">
              <app-button color="primary" rounded="full" (click)="doVtexUpdateRequest()" [loading]="workingLoading">Atualizar</app-button>
              <app-button color="danger" rounded="full" (click)="doVtexDeletionRequest()" [loading]="workingLoading">Excluir</app-button>
            </p>
          }
          @else {
            <p>O usuário não existe no MasterData da VTEX. Deseja criá-lo?</p>
            <p>
              <app-button color="primary" rounded="full" (click)="doVtexCreationRequest()" [loading]="workingLoading">Criar</app-button>
            </p>
          }
        </app-accordion-item>
        <app-accordion-item id="by-user" icon="user" label="Histórico de alterações por usuário">
          <table class="table-auto w-full border-collapse border border-slate-400">
            <thead>
            <tr class="bg-neutral-100 dark:bg-neutral-700">
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Id</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">TraceID</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Action</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">User</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Endereço IP</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Data</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            @for (row of userChangeHistory; track row.auditId; let even = $even) {
              <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
                <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.auditId }}</td>
                <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.traceId }}</td>
                <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ operationType(row.action) }}</td>
                <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                  @if (row.userId != 0) {
                    {{ `${row.userEmail} (${row.userId})` }}
                  } @else {
                    {{ row.userEmail }}
                  }
                </td>
                <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.ipAddress || 'Desconhecido' }}</td>
                <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.date }}</td>
                <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                  <app-button icon="search" color="info" (click)="onOpenEntityModal(row)"></app-button>
                </td>
              </tr>
            } @empty {
              <tr class="bg-neutral-50 dark:bg-neutral-800">
                <td colspan="7" class="border border-neutral-300 dark:border-neutral-600 p-2">Não há alterações para este vendedor.</td>
              </tr>
            }
            </tbody>
          </table>
          <app-pagination [paginationState]="historyPaginationState()" [onPaginationChange]="onUserHistoryPageChange"></app-pagination>
        </app-accordion-item>
        <app-accordion-item id="by-batch" icon="file" label="Histórico de alterações por lote">
          <table class="table-auto w-full border-collapse border border-slate-400">
            <thead>
            <tr class="bg-neutral-100 dark:bg-neutral-700">
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Id</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Ação</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Document ID</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Email</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">Data</th>
              <th class="border border-neutral-300 dark:border-neutral-600 p-2">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
              @for (row of batchChangeHistory; track row.id; let even = $even) {
                <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
                  <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.id }}</td>
                  <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ operationType(row.action) }}</td>
                  <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.documentId || 'Inexistente' }}</td>
                  <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.email }}</td>
                  <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ row.date }}</td>
                  <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                    @if (row.action !== 'NOP') {
                      <app-button icon="search" color="info" (click)="onOpenBatchModal(row)"></app-button>
                    }
                  </td>
                </tr>
              } @empty {
                <tr class="bg-neutral-50 dark:bg-neutral-800">
                  <td colspan="6" class="border border-neutral-300 dark:border-neutral-600 p-2">Não há alterações para este vendedor.</td>
                </tr>
              }
            </tbody>
          </table>
          <app-pagination [paginationState]="batchHistoryPaginationState()" [onPaginationChange]="onBatchHistoryPageChange"></app-pagination>
        </app-accordion-item>
      </app-accordion>
    </div>
  }
</div>

<app-modal #entityModal [title]="modalTitle" class="min-w-[1366px]">
  <div class="max-h-[70vh] overflow-auto min-w-[1366px]">
    @if (modalIsLoading) {
      <app-loading size="large" color="primary"/>
    } @else if (modalError) {
      <app-alert [type]="'danger'">{{ modalError }}</app-alert>
    } @else if (modalOriginalModel && modalModifiedModel) {
      <p>Alterações:</p>
      <div style="min-height: 600px; min-width: 1366px;">
        <ngx-monaco-diff-editor
          style="min-height: 600px;"
          [originalModel]="modalOriginalModel"
          [modifiedModel]="modalModifiedModel"
          [options]="diffOptions"
        ></ngx-monaco-diff-editor>
      </div>
    } @else {
      @if (modalOriginalModel) {
        <p>Entidade antes:</p>
        <pre class="text-xs whitespace-pre-wrap">{{ modalOriginalModel }}</pre>
      }
      @if (modalModifiedModel) {
        <p>Entidade depois:</p>
        <pre class="text-xs whitespace-pre-wrap">{{ modalModifiedModel }}</pre>
      }
    }
  </div>
</app-modal>
